<!-- day posts preview -->
<div class="fixed overflow-hidden shadow-2xl rounded-2xl border-[1px] border-[#eaecef] bg-white w-[60vh] px-2 z-50" [style.height.px]="previewHeight"  [style.left.px]="xpos" [style.top.px]="ypos" *ngIf="isVisible" >
    <div class="relative text-[#544e61] grid grid-cols-9 items-center mr-2 ml-4 mt-2 overflow-hidden" [style.height.px]="40">
        <div (click)="switchToDayView(date)" class="text-4xl text-center font-semibold leading-none col-span-1 cursor-pointer rounded-lg hover:bg-[#e6e6e6] hover:rounded-lg">
                {{date.getDate().toString().padStart(2, '0')}} 
        </div>
        <div class="col-span-4 ml-2 mt-[5px]">
            <div class="uppercase text-xs tracking-widest leading-[1.1] mb-0">{{'dates.days.shortNumber.'+date.getDay() | translate}}.</div>
            <div class="text-sm font-semibold leading-[1.1] mt-0 cursor-pointer">
                <span (click)="switchToMonthView(date.getMonth())">
                    <span class="hover:bg-[#e6e6e6] hover:rounded-lg">
                        {{'dates.months.full.'+(date.getMonth()+1) | translate}} 
                    </span>
                </span>
                <span (click)="switchToYearView(date.getFullYear())" class="hover:bg-[#e6e6e6] hover:rounded-lg">
                    {{date.getFullYear()}}
                </span>
            </div>
        </div>
        <div class="absolute top-0 right-0 text-2xl font-semibold cursor-pointer hover:text-pink-600" style="pointer-events: all;" (click)="close()">×</div>
    </div>
    <div class="w-[57vh] relative overflow-y-auto bg-[#fafafa] py-2" [style.height.px]="previewHeight-60" (scroll)="checkifThereIsMoreTofetch($event)">
        <div
				[@fadeAnimation]="loadPost"
				class="absolute rounded-3xl top-0 bottom-0 left-0 right-0 bg-[#fafafa] z-20 flex items-center justify-center"
				(@fadeAnimation.done)="onAnimationDone($event)"
			>
				<!-- Bouncing dots -->
				<div class="flex justify-center items-center space-x-1">
					<div class="w-2 h-2 rounded-full bg-gray-400 animate-dot1"></div>
					<div class="w-2 h-2 rounded-full bg-gray-400 animate-dot2"></div>
					<div class="w-2 h-2 rounded-full bg-gray-400 animate-dot3"></div>
				</div>
			</div>
        <div *ngFor="let post of data ; index as i" class="pt-2 ml-3 mr-2" >
            <span class="col-span-2 flex items-center py-[2px]" *ngIf="allOff(post)">
                <span class="text-sm ml-1">{{extractHour(post)}}</span>
            </span>
            <app-post-preview 
            *ngIf="allOff(post)"
                [user]="user" 
                [index]="i" 
                [displayAs]="displayAs(post)"
                [postIndex]="i"
                [post]="post"
                [insights]="false"
            />
        </div>
    </div>
</div>
<!-- <app-loader [isLoading]="isLoading"/> -->
